import TabletBasic from "@/views/layouts/TabletBasic";
import TabletMyOrders from "@/views/tablet/orders/List";
import TabletOrder from "@/views/tablet/orders/Order";
import TabletRequests from "@/views/tablet/orders/Requests";
import TabletReport from "@/views/tablet/orders/Report";
import TabletMap from "@/views/tablet/orders/Map";
import TabletLoginLayout from "@/views/layouts/TabletLogin";
import TabletLogin from "@/views/tablet/login/Login";

const routes = [{
  path: '/tablet',
  component: TabletLoginLayout, // Change the desired Layout here
  meta: {requiresAuth: false},
  children: [
    {
      path: 'login',
      component: TabletLogin,
      name: 'TabletLogin',
      meta: {
        permission: true
      }
    },
  ],
}, {
  path: '/tablet',
  component: TabletBasic,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'orders',
      component: TabletMyOrders,
      name: 'TabletMyOrders',
      meta: {
        permission: true
      }
    },
    {
      path: 'order',
      component: TabletOrder,
      name: 'TabletOrder',
      meta: {
        permission: true
      }
    },
    {
      path: 'requests',
      component: TabletRequests,
      name: 'TabletRequests',
      meta: {
        permission: true
      }
    },
    {
      path: 'report',
      component: TabletReport,
      name: 'TabletReport',
      meta: {
        permission: true
      }
    },
    {
      path: 'map',
      component: TabletMap,
      name: 'TabletMap',
      meta: {
        permission: true
      }
    },
  ]
}];

export default routes;
